//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'home',
  components: {
  },
  data () {
    return {
      type:1,
      count:[],
      info:{},
      loginShow:false,
      account:'',
      password:'',
      nav:[
         {
          title:'门店进出场统计',
          path:'/countInOutFactory',
        },
         {
          title:'加工厂进出厂统计',
          path:'/getFactoryData',
        },
        {
          title:'门店取送统计',
          path:'/sendPickCountData',
        },
      ],
    }
  },
  created(){
    if(!this.$func.getLocal('factory_token')){
        this.loginShow = true;
    }
  },
  mounted(){
  },
  methods:{
     login(){
        let that = this;
        if (!that.account) {
            that.$func.showToast('请输入账号');
            return false;
        }
        if (!that.password) {
            that.$func.showToast('请输入密码');
            return false;
        }
        that.$api.loginTemporary({
            account: that.account,
            password: that.password,
        }).then((res)=>{
            if(res){
                that.$func.setLocal('factory_token',res.data.token);
                that.loginShow = false;
            }
        });
    },
    out(){
        this.$func.confirm('确认退出账号？','提示',()=>{
            this.$func.setLocal('factory_token','');
            setTimeout(()=>{
                window.location.reload();
            },300);
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/factoryCountData.vue